<template>
  <BaseCardSection title="Individuální položky" :is-visible="true" :is-optional="false">
    <IndividualItemInsert :cid="cid"/>
    <IndividualItemList :cid="cid"/>
  </BaseCardSection>
</template>

<script>
import IndividualItemInsert from "@/components/calculation/IndividualItemInsert.vue";
import IndividualItemList from "@/components/calculation/IndividualItemList.vue";
import BaseCardSection from "@/components/base/BaseCardSection.vue";

export default {
  name: "CalculationIndividualItems",
  props: {
    cid: {
      type: String,
      require: true,
    }
  },
  components: {
    BaseCardSection,
    IndividualItemInsert,
    IndividualItemList
  }
}
</script>


<style scoped>
</style>